import { IRawDeviation, TRawDeviation } from "@propely/propely-typings";
import { DocumentSnapshot, collection, collectionGroup, getFirestore, where } from "firebase/firestore";
import { chunk } from "lodash";
import { LocalData } from "to-be-removed/LocalData/General/LocalData";
import { Role } from "to-be-removed/LocalData/User/Role";

export class DeviationsLoaderUtils {
  static getCollection = (propertyID: string) => collection(getFirestore(), `properties/${propertyID}/deviations`);
  static getCollectionGroup = () => collectionGroup(getFirestore(), "deviations");
  static getContractorGroupsWhere = (contractorGroups: string[]) => where("contractorGroups", "array-contains-any", contractorGroups);
  static getPropertyIdWhere = (properties: string[]) => where("propertyID", "in", properties);

  static parseIRawDeviationFromDocumentSnapshot = (doc: DocumentSnapshot): IRawDeviation | undefined => {
    const parsed = TRawDeviation.safeParse({
      id: doc.id,
      ...doc.data(),
    });

    if (parsed.success) {
      return parsed.data;
    }
  };

  static getLandlordOrOperationManagerPropertyChunks = () => {
    const landlordOrOperationManagerProperties = LocalData.currentUser.properties.filter((p) => {
      const member = p.members.getData(LocalData.currentUser.id);
      return !p.deleted && (member?.roles.includes(Role.LANDLORD) || member?.isOperationManager);
    });
    const landlordOrOperationManagerChunks = chunk(
      landlordOrOperationManagerProperties.map((p) => p.id),
      30
    );
    return landlordOrOperationManagerChunks;
  };
}

